const namespace = "layour/sidebar";

export const SET_SIDEBAR_VISIBILY = `${namespace}/SET_SIDEBAR_VISIBILY`;

export const setSideBarVisibility = (payload) => ({
  type: SET_SIDEBAR_VISIBILY,
  payload,
});
